import { render, staticRenderFns } from "./accessibility.vue?vue&type=template&id=166aa426&"
var script = {}
import style0 from "./accessibility.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('166aa426')) {
      api.createRecord('166aa426', component.options)
    } else {
      api.reload('166aa426', component.options)
    }
    module.hot.accept("./accessibility.vue?vue&type=template&id=166aa426&", function () {
      api.rerender('166aa426', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/accessibility/accessibility.vue"
export default component.exports